import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/instances/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/instanceModel.js
// module id = 20
// module chunks = 0